<div class="siteOptions" [class.overviewSiteOptions]="ppIsOverview">
  @if (workspaces$ | async; as workspaces) {
    <div class="siteOptions__leftOptions">
      @if (canCreatePoint && !isMobileScreen) {
        <pp-button
          ppId="newPointBtn"
          class="button--icon-left addPointBtn"
          data-m-target="New point button"
          (ppAction)="newPoint()"
          ppStyle="primary"
          ppSize="large"
          [ppDisabled]="!ppDataFetched"
        >
          <img [src]="EIconPath.PLUS" class="plusIcon" />
          <span class="newPointText">{{ 'new_point' | ppTranslate }}</span>
          <span class="newPointShortText">{{ 'point' | ppTranslate }}</span>
        </pp-button>
      }
      <pp-site-filter-dropdown
        [ppDataFetched]="ppDataFetched"
        class="filterDropdown siteOptions__dropdownButton"
        [class.filterOverviewSpacing]="ppIsOverview"
      />
      <pp-site-options-sort-button
        class="siteOptions__dropdownButton"
        [ppDataFetched]="ppDataFetched"
      />
      <pp-site-options-group-button
        class="siteOptions__dropdownButton"
        [ppDataFetched]="ppDataFetched"
      />
      <div id="columnDropdown" class="siteOptions__dropdownButton">
        <pp-button-dropdown
          [ppSrc]="EIconPath.ICON_TABLE_ICON"
          [ppText]="'table_columns' | ppTranslate"
          [ppActive]="columnsDropdownVisible || hiddenColumnsCount > 0"
          (ppAction)="toggleColumnDropdown('columnDropdown')"
          ppTooltip
          id="columnDropdownBtn"
          data-m-target="Table columns button"
          ppTitle="Display Fields"
        />
      </div>
      @if (ppDataFetched) {
        <pp-saved-views-button
          [ppWorkspaceId]="workspace?.workspaceId"
          [ppDataFetched]="ppDataFetched"
          class="siteOptions__dropdownButton"
        />
      }
      @if (canExport) {
        <pp-button-dropdown
          [ppSrc]="EIconPath.ICON_TABLE_EXPORT"
          [ppText]="'export' | ppTranslate"
          [ppActive]="exportModalVisible"
          (ppAction)="export()"
          ppTooltip
          id="exportListBtn"
          data-m-target="Export points button"
          data-test="Export points button"
          [ppTitle]="!exportHidden ? '' : ('export_permission_denied' | ppTranslate)"
          [ppDisabled]="!hasPoints || ppIsTableLoading() || exportHidden"
          class="siteOptions__dropdownButton"
        />
      }
      @if (tableGrouped) {
        <pp-bulk-group-button
          class="siteOptions__dropdownButton"
          [ppDataFetched]="ppDataFetched"
          [ppType]="'table'"
        />
      }
      @if (table?.selectedPointsCount > 0 && ppDataFetched) {
        <pp-floating-actions
          [hidden]="table?.selectedPointsCount === 0 || table?.selectedPointsCount === null"
          [ppNumberOfSelectedPoints]="table?.selectedPointsCount"
          [ppHasRelatedPoints]="table?.hasSelectedPointsWithRelationships"
        />
      }
    </div>
  }

  <div class="siteOptions__rightOptions">
    @if (ppDataFetched) {
      <pp-site-filter class="siteOptions__siteFilter" />
    }

    @if (ppDataFetched) {
      <button
        class="resetTableButton"
        (click)="resetTable()"
        ppTooltip
        [ppTitle]="'reset_table_tooltip' | ppTranslate"
      >
        <span class="resetText">{{ 'reset_table' | ppTranslate }}</span>
        <span class="shortResetText">{{ 'reset' | ppTranslate }}</span>
      </button>
    }

    @if (sitePlanExists) {
      <div>
        <pp-toggle
          ppId="toggleSitePlan"
          data-m-target="Site plan toggle button"
          class="exportListLine"
          (ppAction)="toggleSitePlan(true)"
          [ppChecked]="site.sitePlanVisible"
          ppStyle="blue"
        >
          <span class="siteOptions__sitePlanText">
            <span class="sitePlanToggle">{{ 'site_plan' | ppTranslate }}</span>
            <span class="shortSitePlanToggle">{{ 'plan' | ppTranslate }}</span>
          </span>
        </pp-toggle>
      </div>
    }
  </div>
</div>

@if (workspaces$ | async; as workspaces) {
  <div>
    <!-- Mobile new point -->
    @if (canCreatePoint && isMobileScreen) {
      <pp-mobile-new-point-button (ppAction)="newPoint()" />
    }
    <!-- Mobile site plan toggle -->
    @if (sitePlanExists) {
      <div class="floatingControl--toggle">
        <pp-toggle
          ppId="toggleSitePlan"
          (ppAction)="toggleSitePlan(false)"
          ppStyle="floating"
          aria-label="Site plan toggle"
          [ppChecked]="site.sitePlanVisible"
        />
      </div>
    }
  </div>
}
